import classNames from 'classnames';
import { Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { SpriteSvg, SpriteSvgType } from '../../../../components/sprite-svg';
import { ISystemMenuItem, SystemMenuId } from '../../../../model/system/menu';
import {
  CommonAction,
  ReduxCommonActionType,
} from '../../../../store/modules/common';
import { IRootState } from '../../../../store/reducers';

interface IProps {
  readonly menu: ISystemMenuItem;
  readonly selectedMenuId: number | SystemMenuId | null;
  readonly isSubMenu?: boolean;
}

export const MenuItem = (props: IProps) => {
  const allServiceConfig = useSelector(
    (state: IRootState) => state.games.allServiceConfig
  );

  const menuDispatch = useDispatch<Dispatch<CommonAction>>();
  const renderMenuItem = () => {
    if (props.menu.hidden) {
      return null;
    }
    return (
      // id用作锚点 overview/index中使用
      <li onClickCapture={clickMenu} id={`${props.menu.id}Anchor`}>
        <Link
          to={props.menu.url || ''}
          className={classNames(
            'nav-item',
            props.menu.id === props.selectedMenuId ? 'active' : ''
          )}
        >
          <span className="nav-icon">
            <SpriteSvg
              type={
                props.menu.icon
                  ? (props.menu.icon as SpriteSvgType)
                  : SpriteSvgType.ServiceDefault
              }
            />
          </span>
          <span className="nav-text">{props.menu.name}</span>
        </Link>
      </li>
    );
  };

  const clickMenu = async () => {
    if (props.isSubMenu && allServiceConfig) {
      return;
    }
    menuDispatch({
      type: ReduxCommonActionType.SELECT_MENU_ID,
      result: props.menu.id as SystemMenuId,
    });
  };
  return <ul className="sidebar-nav">{renderMenuItem()}</ul>;
};
